<div class="ui container">
    <app-header-component  [esComplete]="false" [botonFinalizar]="true" [mission_id]="missionId" [score]='score' [title]='instruction' [ot]="ot" [estado]='state'>
    </app-header-component>
    <div id="DATA-COMPLETE-PDF">
        <div style='overflow-x: auto;' style="margin-bottom: 2em;" *ngIf="ot">
            <table class="ui celled structured table unstackable">
                <thead>
                    <tr>
                        <th colspan="2" class="center aligned">DATOS PRELIMINARES</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class='label'>CÓDIGO:<span class='negrita'>{{code}}</span></td>
                        <td class='label'>Denominación:<span class='negrita'>{{ut}}</span></td>


                    </tr>
                    <tr>
                        <td class='label '> OT:<span class='negrita'>{{ot}}</span></td>
                        <td class='label'>Sección:<span class='negrita'>{{section }}</span></td>

                    </tr>
                    <tr>
                        <td class='label'> Fecha:<span class='negrita'>{{when | date: 'dd/MM/yyyy' }}</span></td>
                        <td class='label'>Ejecutante:<span class='negrita'>{{performer}}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="ui divider "></div>
        <div *ngFor="let prefijo of prefijosReferencia; let i = index">
            <app-detalle *ngIf="i <= indiceActual" [instruction]="prefijo"  [esComplete]="true"
                (completed)="onChildComplete(i)">
            </app-detalle>
        </div>
    </div>

    <div class="ui grid">
        <div class="extra content">
            <button style="margin-top: 3em;" class="ui right labeled icon button button-filter primary"
                (click)="goHome()">
                <i class="home
                          icon"></i>
                Volver
            </button>
        </div>
    </div>
</div>